import React, { useState } from 'react';
import { Tabs, Tab, Typography, Box } from '@mui/material';
import OverviewTab from './OverviewTab';
import UsersManagement from './UsersManagement';
import Ordersmanagement from './Ordersmanagement';
import Refundsmanagement from './Refundsmanagement';
import LocalMallIcon from '@mui/icons-material/LocalMall';

// Tab Panel Component
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const DashboardTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>

      <Typography
        variant="h5"

        sx={{
          mt: 2,
          ml: 5,
          mb: 2,
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 700,
          fontSize: '1.5rem',
          lineHeight: 1.334,
          // p: 1,
          color: '#1976d2',
          display: 'inline-block', // Important to restrict underline to text width
          alignItems: 'center',
          borderBottom: '3px solid #1976d2', // Blue underline
        }}
      >
        Order List
      </Typography>


      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
        sx={{
          '& .MuiTabs-indicator': {
            display: 'none',
          },
          '& .MuiTab-root': {
            position: 'relative',
            zIndex: 1,
            m: 1,
            border: '1px solid #1976d244',
            borderRadius: 1,
            textTransform: 'none',
            '&.Mui-selected': {
              color: 'primary.contrastText',
              bgcolor: 'primary.main',
            },
          },
        }}
      >
        {['Overview', 'Users Management', 'Orders Management', 'Refunds Management'].map(
          (label, index) => (
            <Tab
              key={label}
              label={label}
              id={`simple-tab-${index}`}
              aria-controls={`simple-tabpanel-${index}`}
            />
          )
        )}
      </Tabs>

      <TabPanel value={activeTab} index={0}>
        <OverviewTab />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <UsersManagement />
      </TabPanel>

      <TabPanel value={activeTab} index={2}>
        <Ordersmanagement />
      </TabPanel>

      <TabPanel value={activeTab} index={3}>
        <Refundsmanagement />
      </TabPanel>
    </Box>
  );
};

export default DashboardTabs;